
/*
    Filter for getting user records,
    with fields for first name, last name, username,
    and the option to reset
*/

import React, { createRef } from "react";

/*
First Name
Last Name
Username
*/

const defaultState = {
    first_name: "",
    last_name: "",
    username: ""
};

export default class UserManagementFilter extends React.Component {

    constructor(){
        super();
        this.state = defaultState;
        this.firstNameRef = createRef();
    }

    updateValue = (evt) => {
        this.setState({[evt.target.name]: evt.target.value});
    }

    applyFilter = () => {
        const values = {...this.state};
        this.props.applyFilter(values, this.props.toggleFilter);
    }

    resetFilter = () => {
        this.setState(defaultState);
    }

    //
    // set the filter values if there were previously used values
    //
    componentDidMount(){
        if(this.props.filterValues){
            this.setState({...this.props.filterValues});
        }
        this.firstNameRef.current.focus();
    }

    render(){
        return (
            <div className="filter">
                <div className="form-element-horizontal">
                    <label>First name</label>
                    <input ref={this.firstNameRef} type="text" name="first_name" value={this.state.first_name} onChange={this.updateValue} />
                </div>
                <div className="form-element-horizontal">
                    <label>Last name</label>
                    <input type="text" name="last_name" value={this.state.last_name} onChange={this.updateValue} />
                </div>
                <div className="form-element-horizontal">
                    <label>Username</label>
                    <input type="text" name="username" value={this.state.username} onChange={this.updateValue} />
                </div>
                <div className="filter-bar">
                    <div className="option  " onClick={this.resetFilter}>Reset</div>
                    <div className="option  " onClick={this.applyFilter}>Apply Filter</div>
                </div>
            </div>
        )
    }
}